import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const Header = () => (
  <div className='app__header' id='home' >
    <div className='app__header_info app__wrapper_info' >
      <SubHeading title='Hot food in a cool place' />
      <h1 className='app__header-h1' >The Home Of Fine Dining</h1>
      <p className='p__opensans' >Our creative, elevated food and beverage program combines satisfying samples with imaginative twists.
      <br/>From happy hours and family dinners, to special occasions and everything inbetween. We always have something perfect for you.</p>
      <a href='#menu' >
        <button type='button' className='custom__button' >Explore Menu</button>
      </a>
    </div>
    <div className='app__header_img app__wrapper_img' >
      <LazyLoadImage effect='blur' className='img' src={images.welcome} alt='header' />
    </div>
    <div className='app__scroll' >
      <div className='scroll__vertical-line' />
      <a href='#footer' ><p className='p__cormorant' >Scroll</p></a>
    </div>
  </div>
);

export default Header;
